module.exports = __webpack_public_path__ + "roundDecimal.png";